import {Card, Col, Row, Skeleton} from 'antd'

export const CommunitiesSkeleton = ({ count = 2 }) => {
    const CARD_W = 600;
    return (
        <Row gutter={[16, 16]} justify="start" style={{ margin: 16 }}>
            {Array.from({ length: count }).map((_, idx) => (
                <Col key={idx} flex={`0 0 ${CARD_W}px`}>
                    <Card
                        hoverable
                        style={{ width: CARD_W, margin: '0 auto' }}
                        cover={
                            <div style={{ padding: 8, display: 'flex', justifyContent: 'center', gap: 16 }}>
                                <Skeleton.Image active style={{ width: 310, height: 157, borderRadius: 8 }} />
                                <Skeleton active paragraph={{ rows: 3 }} />
                            </div>
                        }
                    />
                </Col>
            ))}
        </Row>
    );
};